import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { DialogsService } from 'app/_services/dialogs/dialogs.service';
import { NotificationService } from 'app/_services/notification.service';
import { EditSchoolDialogComponent } from './edit-school-dialog/edit-school-dialog.component';
import { School, SCHOOL_COLUMNS, SELECTED_COLUMNS } from './schools';
import { ViewSchoolDialogComponent } from './view-school-dialog/view-school-dialog.component';
import { SchoolsService } from 'app/_services/schools.service';

@Component({
    selector: 'app-schools',
    templateUrl: './schools.component.html',
    styleUrls: ['../shared/table-defaults.scss', './schools.component.scss'],
})
export class SchoolsComponent implements OnInit {
    value = '';
    schools: School[];
    schoolNames: string[];
    dataSource: MatTableDataSource<School>;
    removeItems = false;
    isLoading = true;

    selectedColumns = SELECTED_COLUMNS;
    schoolColumns = SCHOOL_COLUMNS;
    columnsToDisplay = ['actions', ...SELECTED_COLUMNS];
    stickyColumns = ['actions', SCHOOL_COLUMNS[0]];

    @ViewChild(MatTable) table: MatTable<School[]>;

    constructor(
        public dialog: MatDialog,
        private dialogSerivce: DialogsService,
        private schoolsService: SchoolsService,
        private notificationService: NotificationService
    ) {}

    isSticky(columns: string[], id: string): boolean {
        return (columns || []).indexOf(id) !== -1;
    }

    ngOnInit(): void {
        this.schoolsService.getSchools().subscribe((schools) => {
            this.schools = schools;
            this.loadDatasource(this.schools);

            // Create list of schools names to pass into dialog for name validation.
            this.schoolNames = this.schools.map((school) => school.schoolName);
            this.isLoading = false;
        });
    }

    typeOf(field: any): any {
        return typeof field;
    }

    trackBy(_index: number, school: School) {
        return school.id;
    }

    loadDatasource(data: School[]): void {
        this.dataSource = null;
        this.dataSource = new MatTableDataSource(data);
    }

    applyFilter(searchTerms: any): void {
        this.dataSource.filter = searchTerms;

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    clearFilter(): void {
        this.dataSource.filter = '';

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    openEditSchoolDialog(school: School, schoolNames: string[], title: string): MatDialogRef<EditSchoolDialogComponent> {
        const config: MatDialogConfig = {
            // disableClose: true,
            width: '450px',
            panelClass: 'edit-school',
            data: { school, schoolNames, title },
        };

        return this.dialog.open(EditSchoolDialogComponent, config);
    }

    addSchool(): void {
        const schools = this.schools;
        const schoolNames = this.schoolNames;
        const title = 'Add School';
        const school = new School();

        const dialogResult = this.openEditSchoolDialog(school, schoolNames, title);

        dialogResult.afterClosed().subscribe((result: School) => {
            if (!result) {
                return;
            }

            this.schoolsService.createSchool(result).subscribe((res) => {
                schools.push(res);
                this.loadDatasource(schools);
                this.notificationService.showSuccess(`New School has been added.`);
            });
        });
    }

    editSchool(school: School): void {
        const schoolNames = this.schoolNames;
        const title = `Edit School - ${school.schoolName}`;

        const dialogResult = this.openEditSchoolDialog(school, schoolNames, title);

        dialogResult.afterClosed().subscribe((result: School) => {
            if (!result) {
                return;
            }

            this.schoolsService.updateSchool(result.id, result).subscribe();

            this.notificationService.showSuccess(`School has been updated.`);
        });
    }

    viewSchool(school: School): void {
        const title = `View School - ${school.schoolName}`;
        const config: MatDialogConfig = {
            width: '450px',
            panelClass: 'view-school',
            data: { school, title },
        };

        this.dialog.open(ViewSchoolDialogComponent, config);
    }

    deleteSchool(school: School): void {
        const dialogResult$ = this.dialogSerivce.OpenConfirmationDialog({
            TitleText: 'Delete School',
            MessageText: 'Are you sure you want to delete this school?',
            OKText: 'Yes, remove school',
            CancelText: 'No',
        });

        dialogResult$.subscribe((result) => {
            if (!result) {
                return;
            }

            const index = this.dataSource.data.indexOf(school, 0);

            if (index > -1) {
                this.dataSource.data.splice(index, 1);
            }

            this.schoolsService.deleteSchool(school.id).subscribe();
            this.table.renderRows();
            this.notificationService.showSuccess(`School have been removed.`);
        });
    }
}
